import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { Section } from '../section/section';
import { Product } from '../../product/dto/product';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import type { SectionWithProducts } from '../section/section-with-products';
import { ProductMenu } from '../product-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { WithinNameCell } from '../../enum/shared/within-name-cell';
import { SectionColumnConfigCannabinoidKey } from '../../enum/shared/section-column-config-cannabinoid-key';
import { SectionColumnConfigState } from '../../enum/shared/section-column-config-state';

export class JimmyMenu extends ProductMenu {
  getThemeClass(): string {
    return 'jimmy-theme';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getShowHeader(): boolean {
    return true;
  }

  getShowFooter(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  override getProductSubtitle(section: Section, product: Product, rowVm: SectionRowViewModel): string | null {
    /**
     * Displaying THC and CBD values inline within the name cell.
     */
    // Visibility check
    const thcState = rowVm?.section?.columnConfig?.get(SectionColumnConfigCannabinoidKey.THC)?.defaultState;
    const cbdState = rowVm?.section?.columnConfig?.get(SectionColumnConfigCannabinoidKey.CBD)?.defaultState;
    const thcDataValue = rowVm?.section?.columnConfig?.get(SectionColumnConfigCannabinoidKey.THC)?.dataValue;
    const cbdDataValue = rowVm?.section?.columnConfig?.get(SectionColumnConfigCannabinoidKey.CBD)?.dataValue;
    const isThcEnabled = thcState === SectionColumnConfigState.Auto || thcState === SectionColumnConfigState.On;
    const isCbdEnabled = cbdState === SectionColumnConfigState.Auto || cbdState === SectionColumnConfigState.On;
    // Get values
    const thc = rowVm.getCannabinoid('THC', thcDataValue);
    const cbd = rowVm.getCannabinoid('CBD', cbdDataValue);
    // Show appropriate value(s)
    if (isThcEnabled && isCbdEnabled) {
      if (thc !== '-' && cbd !== '-') {
        return `THC ${thc} \xa0\xa0 CBD ${cbd}`;
      } else if (thc !== '-') {
        return `THC ${thc}`;
      } else if (cbd !== '-') {
        return `CBD ${cbd}`;
      }
    } else if (isThcEnabled) {
      if (thc !== '-') {
        return `THC ${thc}`;
      }
    } else if (isCbdEnabled) {
      if (cbd !== '-') {
        return `CBD ${cbd}`;
      }
    } else {
      return null;
    }
  }

  getProductWrapperStyling(section: SectionWithProducts, sectionRowViewModel: SectionRowViewModel, odd: boolean) {
    const rowStyling = super.getProductWrapperStyling(section, sectionRowViewModel, odd);
    rowStyling['border-top'] = `1px solid ${this.menuOptions.bodyTextColor}`;
    return rowStyling;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.EdsMarketNarrowSlant.Regular_400, FONT.FuturaPt.Bold_700, FONT.FuturaPt.ExtraBold_800];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/als1vup.css';
  }
}
